'use strict';

const constraints = {
    login : {
        un: {
            presence: {message: "^Username is required"},
            exclusion: {
                within: ["nicklas"],
                message: "'%{value}' is not allowed"
            },
            format: {
                pattern: "[a-z0-9]+",
                flags: "i",
                message: "^Can only contain a-z and 0-9"
            }
        },
        pw: {
            presence: {message:"^Password is required"},
            length: {
                minimum: 6,
                message: "^Must be at least 6 characters"
            }
        }
    },
    register : {
        firstname: {
            presence: {message: "^First name is required"},
            format: {
                pattern: "[a-z]+",
                flags: "i",
                message: "^Can only contain characters a-z"
            }
        },
        lastname: {
            presence: {message: "^Last name is required"},
            format: {
                pattern: "[a-z]+",
                flags: "i",
                message: "^Can only contain characters a-z"
            }
        },
        emailaddress: {
            presence: {message: "^Email address is required"},
            email: {
                message: "^Email does not appear to be valid"
            }
        },
        phonenumber: {
            presence: {message: "^Phone number is required"},
            format: {
                pattern: "[0-9]+",
                flags: "i",
                message: "^Can only contain numbers between 0 and 9"
            }
        },
    },
    forgotpassword: {
        recusername: {
            presence: {message: "^Username is required"},
            format: {
                pattern: "[a-z0-9]+",
                flags: "i",
                message: "^Can only contain characters and numbers"
            }
        }
    },
    forgotusername: {
        recemail: {
            presence: {message: "^Email address is required"},
            email: {
                message: "^Email does not appear to be valid"
            }
        }
    }

};

export default constraints;



// WEBPACK FOOTER //
// ./src/js/validation-constraints.js